import './LoadingStatus.css'

type LoadingStatusProps = {
  label: string
  className?: string
}

export const LoadingStatus = ({ label, className = '' }: LoadingStatusProps) => (
  <div className={`loading-status ${className}`.trim()} role="status" aria-live="polite">
    <span className="loading-status__spinner" aria-hidden="true" />
    <span>{label}</span>
  </div>
)

export default LoadingStatus
